//alert($.browser.msie);
//if($.browser.msie)
if(0)
{

    // Look for CF in the User Agent before trying more expensive checks
    var ua = navigator.userAgent.toLowerCase();
    //alert(ua);
    if (ua.indexOf("chromeframe") >= 0) {

    }
    else
    {

		$("body").load("/wrong_browser/");
		//alert($("body").html());
	};

}
